export const ATTENDANCE_WINDOW_CLOSED = 'ATTENDANCE_WINDOW_CLOSED';
export const ATTENDANCE_CLOSED_MESSAGE = 'Ya no se pueden tomar asistencias para esta sesión';
